import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/auth",
    name: "auth",
    component: () => import("../views/AuthView.vue"),
    meta: {
      title: "Inicia sesión | Punto de venta - Taqui",
    },
  },
  {
    path: "/resetPass",
    name: "resetPass",
    component: () => import("../views/ResetPassView.vue"),
    meta: {
      title: "Restablece tu contraseña | Punto de venta - Taqui",
    },
  },
  {
    path: "/",
    name: "home",
    component: () => import("../views/HomeView.vue"),
    meta: {
      title: "Punto de venta - Taqui",
    },
    children: [
      {
        path: "/reservas",
        redirect: "/reservas/1",
      },
      {
        path: "/reservas/:page",
        name: "reservas",
        component: () => import("../views/ReservasView.vue"),
        meta: {
          title: "Reservas | Punto de venta - Taqui",
        },
      },
      {
        path: "/nuevaReserva",
        name: "nuevaReserva",
        component: () => import("../views/NuevaReservaView.vue"),
        meta: {
          title: "Nueva reserva | Punto de venta - Taqui",
        },
      },
      {
        path: "/nuevaReservaAbono",
        name: "nuevaReservaAbono",
        component: () => import("../views/NuevaReservaAbonosView.vue"),
        meta: {
          title: "Nueva reserva de abono | Backoffice - Taqui",
        },
      },
      {
        path: "/reportes",
        name: "reportes",
        component: () => import("../views/ReportesView.vue"),
        meta: {
          title: "Reportes | Punto de venta - Taqui",
        },
      },
      {
        path: "/entregas",
        name: "entregas",
        component: () => import("../views/EntregasView.vue"),
        meta: {
          title: "Entregas | Punto de venta - Taqui",
        },
      },
      {
        path: "/abonos",
        redirect: "/abonos/1",
      },
      {
        path: "/abonos/:page",
        name: "abonos",
        component: () => import("../views/AbonosView.vue"),
        meta: {
          title: "Reservas de abonos | Backoffice - Taqui",
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to) => {
  document.title = to.meta?.title ?? "Punto de venta - Taqui";
});

export default router;
